import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ScheduledMeetings from "./conductCamp";
import { getCampList } from "services/redux/brandActivtion/conductCamp/action";

const mapStateToProps = (state) => ({
  campList: state.ConductCampReducer.campList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getCampList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ScheduledMeetings);
